<template>
  <div class="stage-container">
    <!-- 左上角 -->
    <div class="data-bar-wrapper">
      <data-command />
    </div>
    <!-- 左下角 -->
    <therapy-setting class="data-panel-wrapper"
                     :isSetting="false" />

    <!-- 右上角 -->
    <div class="contrl-bar-wrapper">
      <therapy-command />
    </div>
    <div id="scenes-container"
         class="full-screen">
      <!-- 训练画布 -->
      <!-- <pending-cover /> -->
      <therapy-canvas />
    </div>

    <!-- 设置-pending弹窗 -->
    <u-dialog class="setting-dialog"
              :visible="setting_visible"
              :onConfirm="setting_option.onConfirm"
              :onClose="setting_option.onClose"
              closeButton
              confirmButton
              :confirmText="setting_option.confirmText"
              :closeText="setting_option.closeText">
      <therapy-setting class="setting-wrapper" />
    </u-dialog>

    <!-- 训练-ending 弹窗 -->
    <u-dialog :visible="ending_visible"
              :title="'训练结束'"
              :onConfirm="over_OnConfirm"
              :onClose="over_OnClose"
              closeButton
              confirmButton
              confirmText="保存数据"
              closeText="关闭窗口">
      <!-- <data-panel /> -->
      <therapy-setting :isSetting="false" />
    </u-dialog>
  </div>
</template>

<script>
import TherapySetting from './TherapySetting/index'
import TherapyCanvas from './TherapyCanvas' // Therapy Canvas
import TherapyCommand from './CommandBar/therapyCommand'
import DataCommand from './CommandBar/dataCommand'
// import DataPanel from './DataPanel' // Local Therapy Data
// // import PendingCover from '@views/components/PendingCover'

import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'stage',
  components: {
    TherapySetting,
    TherapyCanvas,
    TherapyCommand,
    DataCommand,
    // DataPanel,
    // PendingCover,
  },
  data() {
    return {
      isCurConfig: true,
      setting_visible: true,
      ending_visible: false,
      ready_option: {
        onConfirm: this.beforeStart,
        onClose: this.routerBack,
        confirmText: '开始训练',
        closeText: '退出训练',
      },
      pause_option: {
        onConfirm: this.beforeStart,
        onClose: _ => this['therapy/updateStatus']('playing'),
        confirmText: '更新设置',
        closeText: '继续训练',
      },
    }
  },
  computed: {
    ...mapState({
      therapyStatus: state => state.therapy._THERAPY_STATUS_,
    }),
  },
  watch: {
    therapyStatus() {
      this.handleStatus(this.therapyStatus)
    },
  },
  created() {
    this.setting_option = this.ready_option
  },
  destroyed() {
    this.EndTherapy()
  },
  methods: {
    ...mapMutations([
      'therapy/setCurConfig',
      'therapy/clearCurData',
      'therapy/updateStatus',
    ]),
    ...mapActions(['StartVTX', 'EndTherapy', 'PutHistory']),
    handleStatus(status) {
      switch (status) {
        case 'ready':
          this.setting_visible = true
          this.ending_visible = false
          this.setting_option = this.ready_option
          break
        case 'playing':
          this.setting_visible = false
          this.ending_visible = false
          break
        case 'pause':
          this.ending_visible = false
          this.setting_visible = true
          this.setting_option = this.pause_option
          break
        case 'ending':
          this.setting_visible = false
          this.ending_visible = true
          break
        default:
          break
      }
    },
    over_OnConfirm() {
      this.PutHistory()
    },
    over_OnClose() {
      this['therapy/clearCurData']()
      // 训练状态为 'ready' 结束弹窗关闭
      this['therapy/updateStatus']('ready')
    },
    beforeStart: async function() {
      if (window.Views && window.Views.config) {
      // 更新局部设置
        this['therapy/setCurConfig'](window.Views.config)
      }
      // 开始训练
      this.StartVTX()
      // 开始倒计时
      // this.$refs.dataPanel.countDown()
    },
    routerBack() {
      this.$router.go(-1)
    },
  },
}
</script>
<style lang="scss">
@import './stage.scss';
#loading {
  position: absolute;
  width: auto;
  left: 0;
  height: 200px;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 101;
  text-align: center;
  // display:none;
}
#loading > img {
  width: 300px;
  display: none;
  // z-index: 1010;
  // margin: 20px;
}
</style>


